import React, { useState, useEffect } from "react";
import { validateWishlistName } from "helpers/wishlist";
import Image from "components/image";

const NewList = ({ savedLists, newLists, defaultImage, image, name, listId, onUpdate, checked }) => {
	const [listName, setListName] = useState(name || "My Wishlist");
	const [addProduct, setAddProduct] = useState(checked || true);
	const [error, setError] = useState();

	useEffect(() => {
		validateAndSetListName(listName);
	}, []);

	const handleCheckboxChange = () => {
		const newAddToNewList = !addProduct;
		setAddProduct(newAddToNewList);
		onUpdate(listId, listName, newAddToNewList, error);
	};

	const validateAndSetListName = (value) => {
		setListName(value);
		const err = validateWishlistName(value, savedLists, newLists, listId);
		setError(err);

		onUpdate(listId, value, addProduct, err);
	};

	return (
		<div className="w-full">
			<div className="w-full flex justify-between items-center">
				<div className="flex gap-6 items-center w-[90%]">
					{image ?
						<Image image={image} className="size-16" />
						:
						<img src={defaultImage} className="size-16" loading="lazy" />
					}
					<div className="flex flex-col">
						<input
							type="text"
							className="w-full p-3 border text-base md:text-xl"
							autoFocus
							onChange={(e) => {
								validateAndSetListName(e.target.value);
							}}
							required
							value={listName}
						/>
					</div>
				</div>
				<input
					type="checkbox"
					checked={addProduct}
					onChange={handleCheckboxChange}
					onKeyDown={(e) => e.key === "Enter" && handleCheckboxChange()}
					className="cursor-pointer" />
			</div>
			{error && <p className=" text-red-600 text-left pl-20 ml-2">{error}</p>}
		</div>
	);
};

export default NewList;